import * as React from 'react';
import Box from '@mui/material/Box';
import { Snackbar, Alert } from '@mui/material';
import { GridTable } from '../../Sidebar/SidebarStyles';
import ReportFilterForm from '../ReportFilterForm';
import ReportTable from '../ReportTable';
import { fetchFileUploadDetailsData, generateExportExcelforFileUploadDetails } from '../../ApiSevices/ReportApis';

interface TableProps {
    displaysidebar: boolean;
    ComplianceId: number;
}
interface State {
    loading: boolean;
    snackbarOpen: boolean;
    snackbarMessage: any;
    fileDetailsReportData: any[];
    page: number;
    rowsPerPage: number;
    totalCount: number;
    filters: Filters;
}
interface Filters {
    page: number;
    rowsPerPage: number;
    brokerName: string;
    fromDate: any;
    toDate: any;
}

class FileUploadDetailsReport extends React.Component<TableProps, State> {
    constructor(props: TableProps) {
        super(props);
        this.state = {
            loading: false,
            snackbarOpen: false,
            snackbarMessage: '',
            fileDetailsReportData: [],
            page: 0,
            rowsPerPage: 100,
            totalCount: 0,
            filters: {
                page: 0,
                rowsPerPage: 100,
                brokerName: '',
                fromDate: null,
                toDate: null
            }
        };
    }

    fetchData = async (page: number, rowsPerPage: number, filters: Filters) => {
        this.setState({ loading: true });
        try {
            const res = await fetchFileUploadDetailsData(page, rowsPerPage, filters.brokerName, filters.fromDate, filters.toDate, 'false', this.props.ComplianceId || 0);
            if (res?.data?.length > 0) {
                this.setState({
                    fileDetailsReportData: res.data || [],
                    totalCount: res.totalCount || 0,
                    page,
                    rowsPerPage
                });
            } else {
                this.setState({ fileDetailsReportData: [] });
                this.showSnackbar('No data available for the selected inputs.', 'error');
            }
        } catch (error) {
            console.error('Error fetching report data:', error);
        } finally {
            this.setState({ loading: false });
        }
    };

    handleFilterSubmit = (filters: Filters) => {
        this.setState({ filters }, () => {
            this.fetchData(0, this.state.rowsPerPage, filters);
        });
    };

    handleExportExcel = async (filters: Filters) => {
        this.setState({ loading: true });
        try {
            const fileBlob = await generateExportExcelforFileUploadDetails(filters.brokerName, filters.fromDate, filters.toDate, this.props.ComplianceId);

            const url = window.URL.createObjectURL(fileBlob);
            const link = document.createElement('a');
            link.href = url;

            const filename = `FileUploadDetails_Report_${new Date().toISOString().replace(/[:.]/g, '')}.xlsx`;
            link.setAttribute('download', filename);

            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error('Error exporting production report:', error);
        } finally {
            this.setState({ loading: false });
        }
    };

    handlePageChange = (event: unknown, newPage: number) => {
        const { rowsPerPage, filters } = this.state;
        this.fetchData(newPage, rowsPerPage, filters);
    };

    handleRowsPerPageChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const newRowsPerPage = parseInt(event.target.value, 10);
        const { filters } = this.state;
        this.fetchData(0, newRowsPerPage, filters);
    };

    showSnackbar = (message: string, severity: 'error') => {
        this.setState({ snackbarOpen: true, snackbarMessage: message });
    };

    handleCloseSnackbar = () => {
        this.setState({ snackbarOpen: false });
    };

    render() {
        const { loading, fileDetailsReportData, totalCount, page, rowsPerPage, snackbarOpen, snackbarMessage } = this.state;
        const { displaysidebar } = this?.props;

        return (
            <>
                {loading && (
                    <Box sx={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        backgroundColor: 'rgba(255, 255, 255, 0.5)',
                        zIndex: 9999
                    }}>
                        <div className="loader"></div>
                    </Box>
                )}

                <Box
                    sx={{
                        height: 'calc(100vh - 40px)',
                    }}
                >
                    <GridTable displaysidebar={displaysidebar}>
                        <>
                            <Box
                                sx={{
                                    padding: '2px 0',
                                    backgroundColor: '#f8f8f8',
                                    borderBottom: '1px solid #ddd',
                                }}
                            >
                                <span
                                    style={{
                                        fontSize: '12px',
                                        fontWeight: 'bold',
                                        color: '#000',
                                        marginLeft: '8px',
                                        textTransform: 'uppercase',
                                    }}
                                >
                                    FILE UPLOAD DETAILS REPORT
                                </span>
                            </Box>
                            <ReportFilterForm onSubmit={this.handleFilterSubmit} onExport={this.handleExportExcel} showBroker={true} showStatus={false} showFromDate={true} showToDate={true} showGenerteBtn={true} showExcelBtn={true} showSubmitBtn={false} showJobid={false} />

                            <Box sx={{ overflow: 'hidden', height: '100%', width: '100%' }}>
                                <ReportTable data={fileDetailsReportData}
                                    totalCount={totalCount}
                                    page={page}
                                    rowsPerPage={rowsPerPage}
                                    onPageChange={this.handlePageChange}
                                    onRowsPerPageChange={this.handleRowsPerPageChange} />
                            </Box>
                        </>
                        <Snackbar
                            open={snackbarOpen}
                            autoHideDuration={1500}
                            onClose={() => this.setState({ snackbarOpen: false })}
                            anchorOrigin={{ vertical: "top", horizontal: "right" }}
                        >
                            <Alert onClose={() => this.setState({ snackbarOpen: false })} severity="error" sx={{ width: "100%" }}>
                                {snackbarMessage}
                            </Alert>
                        </Snackbar>
                    </GridTable>
                </Box>
            </>
        );
    }
}

export default FileUploadDetailsReport;